import { render } from "./AlamedaUnlocks.vue?vue&type=template&id=7147dca2"
import script from "./AlamedaUnlocks.vue?vue&type=script&lang=js"
export * from "./AlamedaUnlocks.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/AlamedaUnlocks.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7147dca2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7147dca2', __exports__)) {
    api.reload('7147dca2', __exports__)
  }
  
  module.hot.accept("./AlamedaUnlocks.vue?vue&type=template&id=7147dca2", () => {
    api.rerender('7147dca2', render)
  })

}


export default __exports__